export default "__VITE_PUBLIC_ASSET__caeb311f__"